import React from 'react';
import { Container } from 'reactstrap';
import Button from 'components/atoms/button';
import { useDispatch, useSelector } from 'react-redux';
import { useAuth0 } from '@auth0/auth0-react';
import { isMobile } from 'utils/deviceHelper';

const TermsPage = () => {
  const {
    user: { acceptTermsofService },
  } = useDispatch();
  const device = useSelector((state) => state.user.deviceType);
  const { logout } = useAuth0();

  return (
    <Container className="terms-page content">
      {isMobile(device) ? (
        <div className="google-doc-container">
          <div className="google-doc">
            <iframe
              className="terms-page__terms"
              src={process.env.REACT_APP_TERMS_OF_SERVICE}
            />
          </div>
        </div>
      ) : (
        <iframe
          className="terms-page__terms"
          src={process.env.REACT_APP_TERMS_OF_SERVICE}
        />
      )}

      <div className="terms-page__buttons">
        <Button text="Accept" handleClick={acceptTermsofService} />
        <Button
          text="Reject"
          fillBg={false}
          handleClick={() => logout({ returnTo: window.location.origin })}
        />
      </div>
    </Container>
  );
};

export default TermsPage;
